interface SectionProps {
  heading: string;
  content?: string;
  steps?: string[];
}

export default function Section({ heading, content, steps }: SectionProps) {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          {heading}
        </h2>
        {content && (
          <p className="text-lg text-gray-700 text-center mb-8">{content}</p>
        )}
        {steps && (
          <div className="space-y-6">
            {steps.map((step, index) => {
              const parts = step.split(': ');
              const stepNumber = parts[0];
              const stepText = parts[1] || step;

              return (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">
                    {index + 1}
                  </div>
                  <p className="text-lg text-gray-700 pt-0.5">
                    <strong>{stepNumber}:</strong> {stepText}
                  </p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
